import { Box, BoxProps, keyframes } from '@mui/material';
import React, { PropsWithChildren } from 'react';
import { CenteredMui } from '../../utils';

const blinker = keyframes`
  50% {
    opacity: 0.5;
  }
`;

interface Props extends Omit<BoxProps, 'children'> {
  readonly icon?: React.ReactNode;
  readonly message?: React.ReactNode;
}

export const CustomIconWrapper = (p: PropsWithChildren<object>) => {
  return (
    <Box
      sx={{
        '& svg': {
          width: '3rem',
          height: '3rem',
          fontSize: '1.5em',
          '& path, & g': {
            fill: (theme) => theme.palette.primary.main, // $color-Aqua
          },
        },
      }}
    >
      {p.children}
    </Box>
  );
};

// TODO: refactor in helper
export const LoaderMessage = (
  p: PropsWithChildren<{
    className?: string;
  }>,
) => {
  return (
    <Box
      className={p.className}
      sx={{
        fontSize: '1.2rem',
        marginBottom: '1rem',
        color: (theme) => theme.palette.grey[400],
        textTransform: 'uppercase',
      }}
    >
      {p.children}
    </Box>
  );
};

export const Loader = (props: Props) => {
  const { message, icon, ...rest } = props;

  return (
    <CenteredMui
      {...rest}
      sx={{
        animation: `${blinker} 1.2s linear infinite`,
        ...rest.sx,
      }}
    >
      {message && <LoaderMessage>{message}</LoaderMessage>}
      <Box
        sx={{
          borderRadius: '50%',
          textAlign: 'center',
          fontSize: '2rem',
          color: '#92e1fe', // $color-AquaLight
        }}
      >
        {icon}
      </Box>
    </CenteredMui>
  );
};
